/**
 * Asynchronously loads the component for WelcomePage
 */

import loadable from 'utils/Loadable'
import { LoadingPage } from 'components/Loading'

export default loadable(() => import(/* webpackChunkName: "WelcomePage" */ './index'), {
  fallback: <LoadingPage delay={1} />
})
